import {SET} from "./actionTypes";

export function startMeasuring(time) {
  return dispatch => {
    dispatch({
      type: SET,
      time: time ? time : Date.now()
    })
  }
}

export function getCurrentMicroTime(startTime) {
  return Date.now() - startTime;
}